import usePPDataVariables from './usePPDataVariables';

export * from './usePPDataVariables';
export default usePPDataVariables;
